import Vue from 'vue';
import Router from 'vue-router';
import Introduction from './views/Introduction.vue';

import BreadcrumbContainer from './views/BreadcrumbContainer.vue';

import AtlasesLister from './components/atlases/Lister.vue';
import AtlasDetails from './components/atlases/Detail.vue';

import VideosLister from './components/videos/Lister.vue';
import VideoDetails from './components/videos/Detail.vue';

import ExamsLister from './components/exams/Lister.vue';
import ExamDetails from './components/exams/Detail.vue';

import ExerciseLister from './components/exercises/Lister.vue';
import SummaryLister from './components/summaries/Lister.vue';

import Contact from './components/contact/index.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      name: 'Introdução',
      component: Introduction,
    },
    {
      path: '/atlas',
      component: BreadcrumbContainer,
      meta: { placeholder: 'Lista de atlas' },
      children: [
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: '',
          name: 'Atlas',
          component: AtlasesLister,
        },
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: ':atlasID',
          meta: { breadcrumb: 'currentAtlas', placeholder: 'Detalhes sobre atlas' },
          component: AtlasDetails,
        },
      ],
    },
    {
      path: '/exames',
      meta: { placeholder: 'Lista de exames' },
      component: BreadcrumbContainer,
      children: [
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: '',
          name: 'Exames',
          component: ExamsLister,
        },
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: ':examID',
          meta: { breadcrumb: 'currentExam', placeholder: 'Exame' },
          component: ExamDetails,
        },
      ],
    },
    {
      path: '/videos',
      component: BreadcrumbContainer,
      meta: { placeholder: 'Lista de capítulos de vídeos' },
      children: [
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: '',
          name: 'Videos',
          component: VideosLister,
        },
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: ':videoChapterID',
          meta: { breadcrumb: 'currentVideoChapter', placeholder: 'Capítulo de vídeos' },
          component: VideoDetails,
        },
      ],
    },
    {
      path: '/exercicios',
      component: BreadcrumbContainer,
      meta: { placeholder: 'Exercícios' },
      children: [
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: '',
          name: 'Exercicios',
          component: ExerciseLister,
        },
      ],
    },
    {
      path: '/resumos',
      component: BreadcrumbContainer,
      meta: { placeholder: 'Resumos' },
      children: [
        {
          // UserProfile will be rendered inside User's <router-view>
          // when /user/:id/profile is matched
          path: '',
          name: 'Resumos',
          component: SummaryLister,
        },
      ],
    },
    {
      path: '/contato',
      component: Contact,
    },
  ],
});
